import React from 'react';
import PropTypes from 'prop-types';
import {validationLogin} from '../../../../utils/validationUtils';
import {Button, buttonTypes} from '../../../../components/Button/index';
import Input from '../../../../components/Input/index';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
      error: {},
      email: '',
      password: ''
    }
  }

  componentWillReceiveProps(next) {
    this.setState({
      error: {...next.error}
    })
  }

  static propTypes = {
    submit: PropTypes.func,
    showRegistration: PropTypes.func,
    showResetPassword: PropTypes.func,
  };

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    }, () => {
      // this.setState({error: {}})
    });
  }

  handleSubmit() {
    const data = {...this.state};
    const isValid = validationLogin(data);
    if (isValid.isError) {
      this.setState({...isValid})
    } else {
      this.props.submit({
        email: data.email,
        password: data.password
      })
    }
  }


  render() {
    const {
      error,
      email,
      password
    } = this.state;

    const {
      showResetPassword
    } = this.props;

    return (
      <div className="booking__block">
        <Input
          type="text"
          label="E-mail address"
          placeholder="Email"
          value={email}
          name="email"
          error={error.email}
          onChange={(e) => this.handleChange(e)}
        />
        <Input
          type="password"
          label="Password"
          placeholder="Password"
          value={password}
          name="password"
          error={error.password}
          onChange={(e) => this.handleChange(e)}
        />
        <Button
          name="Log In"
          type={buttonTypes.AUTHENTICATION}
          onClick={() => this.handleSubmit()}
        />
        <div className="booking__link">
          <div className="footer_block">
            <span className="modal__question">Forgot password ?</span>
            <Button
              type={buttonTypes.LINK}
              name="Reset Password"
              onClick={() => showResetPassword(email)}
            />
          </div>
          <div className="footer_block">
            <span>Not a member?</span>
            <Button
              type={buttonTypes.LINK}
              name="Sign up"
              onClick={this.props.showRegistration}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/app/containers/Booking/components/auth/login.js